var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initializing)?_c('div',{staticClass:"d-flex justify-center align-center pa-5"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color}})],1):_c('div',[_c('filter-model-selector',{attrs:{"selection-mode":true},on:{"update-model":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }